import { hero1Image, hero1MobileImage } from "../images";

export const heroData = [
	{
		imageSource: [hero1Image, hero1MobileImage],
	},
];

export const welcomeData = [
	{
		heading: "Looking to volunteer? We’d love to hear from you.",
		description: [
			"Our volunteers are an integral part of the success of our programs. A huge proportion of our volunteer activities are currently organised as virtual programs and flexible with your availability and schedule. Your volunteer activities include event planning, program administration, career educators, community educators, etc.",
			"Are you interested in learning more about mentoring, community development and youth empowerment? Do you want to develop your intellectual, emotional, social and moral well-being? Do you want to put a smile on the faces of your community and those in developing nations? We would love to hear from you!",
		],
	},
];
